import { createTheme } from '@mui/material/styles';

// Шрифти теми салону (білий список має збігатися з бекендом settings.controller.js).
export const FONT_MAP = {
  Montserrat: "'Montserrat', system-ui, sans-serif",
  Inter: "'Inter', system-ui, sans-serif",
  Poppins: "'Poppins', system-ui, sans-serif",
  'Playfair Display': "'Playfair Display', Georgia, serif",
  Lora: "'Lora', Georgia, serif",
  Roboto: "'Roboto', system-ui, sans-serif",
};

// Підвантажити Google-шрифт (ідемпотентно) для брендованої сторінки салону.
export const loadGoogleFont = (font) => {
  if (!font || font === 'Montserrat' || typeof document === 'undefined') return;
  const id = `gf-${font.replace(/\s+/g, '-')}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(font).replace(/%20/g, '+')}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
};

const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

// Читабельний колір тексту (чорний/білий) поверх довільного тла — за яскравістю.
export const readableText = (hex, fallback = '#ffffff') => {
  if (!HEX.test(hex || '')) return fallback;
  let h = hex.slice(1);
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  // Відносна яскравість (sRGB) — поріг 0.6 щоб текст був контрастним
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? '#1f2937' : '#ffffff';
};

// Тло шапки салону: явний header → primary → платформний дефолт.
export const headerColor = (theme = {}) => theme.header || theme.primary || '#1f2937';

// Побудувати MUI-тему з платформної бази + збережених кольорів/шрифту салону.
// Підтримує: primary, accent, background (тло сторінки), surface (картки),
// text (основний текст), font.
export const buildSalonTheme = (baseTheme, theme = {}) => {
  const t = theme || {};
  const hasAny =
    t.primary || t.accent || t.font || t.background || t.surface || t.text;
  if (!hasAny) return baseTheme;
  return createTheme(baseTheme, {
    palette: {
      ...(t.primary ? { primary: { main: t.primary } } : {}),
      ...(t.accent ? { secondary: { main: t.accent } } : {}),
      ...(t.background || t.surface
        ? {
            background: {
              ...(t.background ? { default: t.background } : {}),
              ...(t.surface ? { paper: t.surface } : {}),
            },
          }
        : {}),
      ...(t.text ? { text: { primary: t.text } } : {}),
    },
    ...(t.font && FONT_MAP[t.font]
      ? { typography: { fontFamily: FONT_MAP[t.font] } }
      : {}),
  });
};
